// packages/content/src/tuning/safety.ts (M2-T04, rev 5) — the report note cap, the admin report page size, and how many reports one
// member may file in an hour (each one emails the admins; abuse limits §14)
import type { TuningBank } from '../schema/tuning';
export default { reportNoteMaxChars: 500, adminListLimit: 200, reportsPerHour: 10 } as const satisfies TuningBank;
